import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { ButtonComp, TextAreaComp } from "../../../../components";
import { toast } from "react-hot-toast";
import { useSendBirthdayWishMutation } from "../../../../store/member/memberBirthdaySlice";
import { IoClose } from "react-icons/io5";

const BirthdayWishModal = ({ show, onHide, recipient }) => {
  const [template, setTemplate] = useState("Happy Birthday! 🎉");
  const [customMessage, setCustomMessage] = useState("");
  const [sendWish, { isLoading }] = useSendBirthdayWishMutation();

  const templates = [
    "Happy Birthday! 🎉",
    "Wishing you a wonderful day filled with joy! 🎂",
    "May your special day be as amazing as you are! 🌟",
    "Happy Birthday! Have a fantastic celebration! 🎈",
  ];

  const handleSend = async () => {
    try {
      const payload = {
        recipient_id: recipient.id,
        message: customMessage || template,
      };
      const response = await sendWish(payload).unwrap();
      if (response.status) {
        toast.success(`Birthday wish sent to ${recipient.name}! 🎂`);
        onHide();
      } else {
        toast.error(response.message || "Failed to send wish");
      }
    } catch (error) {
      toast.error("An error occurred while sending wish");
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered className="rounded-4">
      <Modal.Header className="border-0 pb-0 position-relative">
        <Modal.Title className="fw-bold h5 text-center w-100 mt-2">
          Send Birthday Wish to {recipient?.name}
        </Modal.Title>
        <button
          onClick={onHide}
          className="position-absolute border-0 bg-transparent"
          style={{ top: "15px", right: "15px", color: "var(--color-primary)" }}
        >
          <IoClose size={24} />
        </button>
      </Modal.Header>
      <Modal.Body className="px-4 pb-4">
        <div className="mb-4">
          <label className="fw-bold mb-3 small text-blacklight">Choose a quick template</label>
          <div className="space-y-2">
            {templates.map((t, i) => (
              <div
                key={i}
                className={`p-3 rounded-10 border pointer transition-all ${
                  template === t && !customMessage
                    ? "border-primary1 bg-light"
                    : "border-gray2 hover:bg-gray3"
                }`}
                onClick={() => {
                  setTemplate(t);
                  setCustomMessage("");
                }}
              >
                <div className="form-check m-0">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="birthday_template"
                    checked={template === t && !customMessage}
                    readOnly
                  />
                  <label className="form-check-label ms-2 pointer">{t}</label>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-4">
          <label className="fw-bold mb-2 small text-blacklight">Or write a custom message</label>
          <TextAreaComp
            placeholder="Add a personal message (optional)..."
            rows={3}
            value={customMessage}
            onChange={(e) => setCustomMessage(e.target.value)}
            style={{ borderRadius: "10px" }}
          />
        </div>

        <ButtonComp
          btnText={isLoading ? "Sending..." : "Send Birthday Wish"}
          btnClassName="w-100 bg-primary1 text-white py-3 rounded-10 border-0 shadow"
          onClick={handleSend}
          disabled={isLoading}
        />
      </Modal.Body>
    </Modal>
  );
};

export default BirthdayWishModal;

